<template>
    <div style="background: #f4f4f4; width: 100%; height: 100%; position: relative;">
        <loginHeader />
        <div class="login_root_box">

            <div v-if="state == 0" class="login_center_box" style="padding-top: 5%;">
                <div class="login_box_title">忘记密码</div>
                <div style="overflow: hidden;width: 400px; height: 48px;margin: 30px auto;">
                    <input type="text" v-model="tel" class="input" style="width: 100%;" name="" placeholder="请输入已验证手机号码"
                        id="">
                </div>
                <div style="overflow: hidden;width: 400px; height: 48px;margin: 30px auto;">
                    <div v-if="yzm_code" class="yzm_but" style="cursor: pointer;" @click="sendCode">{{yzm_txt}}</div>
                    <div v-else class="yzm_but" style="cursor: pointer; background: #BFBFBF; color: #fff;">{{yzm_txt}}
                    </div>
                    <input type="text" v-model="yzm" class="input" style="width: 60%;" name="" placeholder="请输入短信验证码"
                        id="">
                </div>
                <div class="login_but" @click="xiayibu1" style="width: 400px;cursor: pointer;">下一步</div>
            </div>

            <div v-if="state == 1" class="login_center_box" style="padding-top: 5%;">
                <div class="login_box_title">重置密码</div>
                <div style="width: 500px; margin: auto; position: relative;">
                    <div style="overflow: hidden;width: 400px; height: 48px;margin: 30px auto; position: relative;">
                        <input v-model="paw1" :type="paw_type1" class="input" style="width: 100%;" name=""
                            placeholder="6-16位字符，可包含数字、字母(区分大小写)、特殊符号" id="">
                        <img src="../assets/wangjimima_zhengque.png" alt="" class="wangjimima_right_icon">
                    </div>
                    <div style="cursor: pointer;" @click="changPawShow1">
                        <img v-if="paw_show1" src="../assets/wangjimima_kanbujian.png" class="yanjin" alt="">
                        <img v-else style="width: 17px; height: 10px;" src="../assets/wangjimima_kandejian.png"
                            class="yanjin" alt="">
                    </div>
                </div>
                <div style="width: 500px; margin: auto; position: relative;">
                    <div style="overflow: hidden;width: 400px; height: 48px;margin: 30px auto; position: relative;">
                        <input v-model="paw2" :type="paw_type2" class="input" style="width: 100%;" name="" placeholder="请再次输入新密码"
                            id="">
                        <img src="../assets/wangjimima_zhengque.png" alt="" class="wangjimima_right_icon">
                    </div>
                    <div style="cursor: pointer;" @click="changPawShow2">
                        <img v-if="paw_show2" src="../assets/wangjimima_kanbujian.png" class="yanjin" alt="">
                        <img v-else style="width: 17px; height: 10px;" src="../assets/wangjimima_kandejian.png"
                            class="yanjin" alt="">
                    </div>
                </div>
                <div @click="xiayibu2" class="login_but" style="width: 400px; cursor: pointer;">确定</div>
            </div>


            <div v-if="state == 2" class="login_center_box" style="padding-top: 5%;">
                <div style="margin: 5% auto; width: 50%;">
                    <div style="overflow: hidden;">
                        <img src="../assets/wangjimima1.png" style="width: 50px; height: 57px; float: left;" alt="">
                        <div style="float: left; margin-left: 40px;">
                            <div class="chenggong_txt1">密码修改成功！</div>
                            <div class="chenggong_txt2">请牢记您的新密码，以后请使用新密登录</div>
                        </div>
                    </div>
                    <router-link to="/login"><div class="lijidenglu">立即登录</div></router-link>
                </div>
            </div>


        </div>

        <loginFoot />
    </div>
</template>

<script>
    import axios from "axios";
    import loginHeader from '../public/login_head'
    import loginFoot from '../public/login_foot'
    export default {
        name: "integral",
        components: {
            loginHeader,
            loginFoot
        },
        data() {
            return {
                state: 0, // 步骤
                tel: "",
                yzm: "",
                yzm_txt: "获取验证码",
                count: 0,
                paw_show1: false,
                paw_type1: 'password',
                paw_show2: false,
                paw_type2: 'password',
                yzm_code: true,
                paw1: '',
                paw2: '',
            };
        },
        methods: {
            // 重置密码
            xiayibu2() {
                if(this.paw1 == '' || this.paw2 == '') {
                    this.$message.error("密码不能为空");
                    return false
                }
                if(this.paw1 != this.paw2) {
                    this.$message.error("两次输入不一致");
                    return false
                }
                this.api.verifycode_reset_pwd({ mobile: this.tel, pwdCopy: this.paw2, pwd: this.paw1 }).then(res => {
                    if(res.ok) {
                        this.$message.success(res.message)
                        this.state = 2
                    }else {
                        this.$message.error(res.message)
                    }
                })
            },
            // 验证验证码
            xiayibu1() {
                if (!/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(this.tel)) {
                    this.$message.error("请输入正确的手机号");
                    return false;
                }
                if (this.yzm == '') {
                    this.$message.error("请输入验证码");
                    return false;
                }
                this.api.forgetPwd_valid({ mobile: this.tel, verifycode: this.yzm }).then(res => {
                    if (res.ok) {
                        this.state = 1
                    } else {
                        this.$message.error(res.message);
                    }
                })
            },
            // 切换显示隐藏
            changPawShow1() {
                this.paw_show1 = !this.paw_show1
                this.paw_type1 = this.paw_type1 == 'text' ? 'password' : 'text'
            },
            changPawShow2() {
                this.paw_show2 = !this.paw_show2
                this.paw_type2 = this.paw_type2 == 'text' ? 'password' : 'text'
            },
            // 发送验证码
            sendCode() {
                if (!/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(this.tel)) {
                    this.$message.error("请输入正确的手机号");
                    return false;
                }
                this.api.forgetPwd_verifycode(this.tel).then((res) => {
                    if (res.ok) {
                        this.yzm_code = false;
                        this.countdown(60);
                        this.$message.success(res.message);
                    } else {
                        this.$message.error(res.message);
                    }
                });
            },
            // 倒计时
            countdown(count) {
                setTimeout(() => {
                    count -= 1;
                    if (count) {
                        this.yzm_txt = count + "s后重新获取";
                        this.countdown(count);
                    } else {
                        this.yzm_txt = "重新获取";
                        this.yzm_code = true;
                    }
                }, 1000);
            },
        },
        created() {

        },
    };
</script>

<style scoped>
    .lijidenglu {
        width: 200px;
        height: 48px;
        border: 1px solid #2C9A34;
        text-align: center;
        line-height: 48px;
        margin: 40px auto;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #2C9A34;
    }

    .chenggong_txt1 {
        font-size: 22px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #343434;
    }

    .chenggong_txt2 {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        margin-top: 10px;
    }

    .yanjin {
        position: absolute;
        right: 20px;
        top: 50%;
        margin-top: -4px;
        width: 16px;
        height: 8px;
    }

    .wangjimima_right_icon {
        position: absolute;
        width: 16px;
        height: 16px;
        right: 10px;
        top: 50%;
        margin-top: -8px;
    }

    .yzm_but {
        width: 40%;
        height: 100%;
        float: right;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #2B9A34;
        text-align: center;
        line-height: 48px;
        border: 1px solid #EDE9E9;
        border-left: none;
    }

    .quhao {
        width: 20%;
        height: 100%;
        float: left;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        text-align: center;
        line-height: 48px;
        border: 1px solid #EDE9E9;
        border-right: none;
    }

    .qitafangshi_txt {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
    }

    .duanxindenglu {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #2B9A34;
        text-align: center;
    }

    .wangjimima {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        float: right;
    }

    .zidongdenglu {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
    }

    .login_but {
        width: 340px;
        height: 48px;
        background: #2B9A34;
        text-align: center;
        line-height: 48px;
        margin: 20px auto;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
    }

    .input {
        width: 80%;
        height: 100%;
        float: left;
        border: 1px solid #EDE9E9;
        display: block;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        padding-left: 10px;
        outline: none;
    }

    .login_box_title {
        font-size: 22px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        margin-top: 20px;
        text-align: center;
    }

    .login_root_box {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .login_center_box {
        width: 800px;
        height: 520px;
        background: #FFFFFF;
    }

    html,
    body,
    #app {
        background: #f4f4f4 !important;
    }

    .bottom_nav_items {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #343434;
        text-align: center;
        width: 20%;
        float: left;
    }

    .top_title1 {
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #1A1A1A;
        float: left;
        margin-left: 2%;
    }

    .login_lianxifangshi {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #1A1A1A;
    }
</style>



// WEBPACK FOOTER //
// src/components/wangjimima.vue